import {combineReducers, configureStore} from '@reduxjs/toolkit';
import authSlice  from './features/auth-slice';
import restaurantSlice from './features/restuarant-slice';
import employeeSlice from './features/employee-slice';
import categorySlice from './features/category-slice';
import comboSlice from './features/combo-slice';
import restaurantTableSlice from './features/restuarant-table-slice';
import menuItemSlice from './features/menu-item-slice';
import modifierCategoriesSlice from './features/modifier-categories-slice';
import modifierItemsSlice from './features/modifier-items-slice';
import eventsSlice from './features/events-slice';
import cartsOrderSlice from './features/carts-order';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
const rootReducer = combineReducers({
    auth: authSlice,
    restaurant: restaurantSlice,
    employee: employeeSlice,
    category: categorySlice,
    restaurantTable: restaurantTableSlice,
    menuItem: menuItemSlice,
    modifierCategories: modifierCategoriesSlice,
    modifierItems: modifierItemsSlice,
    events: eventsSlice,
    combo: comboSlice,
    cartsOrder: cartsOrderSlice,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [], 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer
})

const persistor = persistStore(store);

// Export RootState type for TypeScript
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export {store, persistor};